module.exports = __webpack_public_path__ + "media/images/file-icons/512/004-folder-1-e7d6ad898fd0e822c18c0ffffadf29c3.png";